var exports = {
  "pW": "leadingVisual__m-j1ds",
  "Kk": "icon__2Wa4MQ",
  "LX": "trailingVisual__0nvT5d",
  "rb": "mainContent__5_MaCR",
  "sU": "trailingContent__64sUDk",
  "z7": "completedIterationHeading__bHVDvt",
  "Un": "todayLabel__cC9jvi",
  "uz": "toggleEmptyButton__ow5Z8l",
  "h_": "description__PsVtvp",
  "DD": "title__4j8iab",
  "yR": "parentIssueTitle__mmSoDU",
  "Tj": "listContainerBase__OCLdja",
  "IL": "actionListItem__ZKT_di",
  "yH": "actionListItemActive__hki5Bi",
  "JB": "actionListItemContainer__vP9Yjn",
  "fx": "withIcons__M0w5Ia",
  "Us": "leadingContent__qlf-ZP",
  "uW": "noIcons__cu2V4O",
  "VA": "SlicerPanel__Cj5ISm",
  "a": "WritePermissions__rUBxXG",
  "Kp": "Wide__FUaLvu",
  "f9": "itemFullWidth__zUlnnL",
  "W2": "itemRight__11IPXe",
  "gK": "Narrow__DIkymO",
  "FM": "CurrentIterationLabel__rJdTOo",
};

module.exports = exports;
